import { formatImageUrl, stripHtml } from '../../utils/security';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'https://orbitronix.ge/api/';

const ServicePortfolio = ({ category }) => {
    const { t } = useTranslation();
    const { lang } = useParams();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProjects = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${API_URL}portfolios.php?lang=${lang}&category=${category}`);
                const data = await response.json();
                setProjects(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching portfolios:', error);
            }
            setLoading(false);
        };
        fetchProjects();
    }, [lang, category]);

    if (loading || projects.length === 0) return null;

    return (
        <div className="mt-50">
            <h3 className="text-white mb-30">{t('common.ourProjects', 'Our Projects')}</h3>
            <div className="row">
                {projects.map((project) => {
                    let imageUrl = formatImageUrl(project.image);
                    return (
                        <div className="col-lg-6 mb-30" key={project.id}>
                            <Link
                                to={`/${lang}/portfolio/${project.slug}`}
                                style={{
                                    display: 'block',
                                    background: '#0c1130',
                                    border: '1px solid #1e115b',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    textDecoration: 'none',
                                    transition: 'all 0.3s'
                                }}
                                onMouseEnter={e => { e.currentTarget.style.borderColor = '#6c5ce7'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
                                onMouseLeave={e => { e.currentTarget.style.borderColor = '#1e115b'; e.currentTarget.style.transform = 'translateY(0)'; }}
                            >
                                {imageUrl && (
                                    <div style={{ height: '180px', overflow: 'hidden' }}>
                                        <img src={imageUrl} alt={project.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                )}
                                <div style={{ padding: '20px' }}>
                                    <h5 className="text-white mb-2" style={{ fontSize: '16px' }}>{project.title}</h5>
                                    <p className="text-white-50 mb-0" style={{ fontSize: '13px', lineHeight: '1.6' }}>
                                        {project.summary ? stripHtml(project.summary).substring(0, 100) + '...' : ''}
                                    </p>
                                </div>
                            </Link>
                        </div>
                    );
                })}
            </div>
            <div className="mt-20">
                <Link to={`/${lang}/portfolio`} className="orbx-btn-outline" style={{ display: 'inline-block', textDecoration: 'none' }}>
                    {t('common.viewAll', 'View All')} <i className="fas fa-arrow-right ms-2"></i>
                </Link>
            </div>
        </div>
    );
};

export default ServicePortfolio;
